import { computed, onBeforeUnmount, onMounted, ref } from "vue";

type ServiceWorkerUpdatedDetail = {
  waiting: {
    postMessage: (message: { type?: string }) => void;
  };
};

export function useServiceWorkerUpdate() {
  const updateExists = ref(false);
  const isRefreshingForUpdate = ref(false);
  const serviceWorkerRegistration = ref<ServiceWorkerUpdatedDetail | undefined>();

  const canRefresh = computed(
    () => updateExists.value && serviceWorkerRegistration.value?.waiting !== undefined
  );

  function promptUpdateAvailable(
    event: CustomEvent<ServiceWorkerUpdatedDetail>
  ) {
    serviceWorkerRegistration.value = event.detail;
    updateExists.value = true;
  }

  function serviceWorkerChanged() {
    if (isRefreshingForUpdate.value) {
      return;
    }

    isRefreshingForUpdate.value = true;
    window.location.reload();
  }

  function refreshApp() {
    updateExists.value = false;
    serviceWorkerRegistration.value?.waiting?.postMessage({
      type: "SKIP_WAITING",
    });
  }

  onMounted(() => {
    document.addEventListener(
      "serviceWorkerUpdated",
      promptUpdateAvailable as EventListener,
      { once: true }
    );

    navigator.serviceWorker?.addEventListener(
      "controllerchange",
      serviceWorkerChanged
    );
  });

  onBeforeUnmount(() => {
    document.removeEventListener(
      "serviceWorkerUpdated",
      promptUpdateAvailable as EventListener
    );

    navigator.serviceWorker?.removeEventListener(
      "controllerchange",
      serviceWorkerChanged
    );
  });

  return {
    canRefresh,
    refreshApp,
    updateExists,
  };
}
